import React, { useEffect, useState } from "react";
import classes from "./CostToStudy.module.scss";
import CustomImage from "../../CustomImage";

const CostToStudy = ({ countryData }: { countryData: any }) => {
  const [activeTab, setActiveTab] = useState<string>("cost-of-study");
  const [cardsArr, setCardsArr] = useState<any>([]);
  const costToStudySectionData = countryData?.costToStudySection;

  useEffect(() => {
    let tempCardsArr = activeTab === "cost-of-study" ? (costToStudySectionData?.costOfEducation ?? []) : (costToStudySectionData?.costOfLiving ?? []);
    setCardsArr(tempCardsArr ?? []);
  }, [costToStudySectionData, activeTab]);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };

  const hasPriorityBanner = Boolean(countryData?.banner_1?.priorityImage?.url);

  return (
    <div id="cost" className={`${classes["cost-to-study-container"]}${hasPriorityBanner ? ` ${classes["cost-to-study-container--priority-banner"]}` : ""}`}>
      <div className={classes["cost-card"]}>
        <h2 className={classes["cost-card-title"]}>{costToStudySectionData?.title ?? ""}</h2>

        <div className={classes["cost-card-description"]} dangerouslySetInnerHTML={{ __html: costToStudySectionData?.description ?? "" }}></div>

        <div className={classes["cost-card-features"]}>
          <div className={classes["tab-container"]}>
            {costToStudySectionData?.costOfEducation?.length > 0 && (
              <button
                className={`${classes["study-tab-button"]} ${activeTab === "cost-of-study" && classes["active-tab"]}`}
                onClick={() => handleTabClick("cost-of-study")}
              >
                Cost of Study
              </button>
            )}
            {costToStudySectionData?.costOfLiving?.length > 0 && (
              <button
                className={`${classes["living-tab-button"]} ${activeTab === "cost-of-living" && classes["active-tab"]}`}
                onClick={() => handleTabClick("cost-of-living")}
              >
                Cost of Living
              </button>
            )}
          </div>

          <div style={cardsArr.length === 1 ? { justifyContent: "center" } : {}} className={classes["cards-container"]}>
            {cardsArr.map((el: any, index: number) => (
              <div style={cardsArr.length === 1 ? { width: "fit-content" } : {}} className={classes["card"]} key={index}>
                <div className={classes["card-icon"]}>
                  <CustomImage src={el?.icon ?? "/icons/graduation_cap.svg"} alt={el?.expenseType ?? ""} width={"100%"} height={"100%"} />
                </div>
                <div className={classes["card-content"]}>
                  <div>
                    <h3 className={classes["card-title"]}>{el?.expenseType ?? ""}</h3>
                    <p className={classes["card-desc"]}>{el?.description ?? ""}</p>
                  </div>
                  <div>
                    <p className={classes["card-fees"]}>{el?.degree ?? ""}</p>
                    <p className={classes["card-currency-info"]}>{el?.expenseInfo ?? "Annual Expenses in US$"}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostToStudy;
